<template>
  <div>
    <!-- edit card modal -->
    <modal
      name="edit-card-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-card
        :selectedCard="selectedCard"
        :isSaveAndProceedButtonVisible="false"
        title="UREDI KARTICU"
        @saveAndCloseButtonClicked="editCard"
      />
    </modal>

    <!-- add card modal -->
    <modal
      name="add-card-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-card
        :selectedCard="selectedCard"
        :isSaveAndProceedButtonVisible="false"
        title="DODAJ KARTICU"
        @saveAndCloseButtonClicked="addCard"
      />
    </modal>

    <!-- delete card modal -->
    <modal
      name="delete-card-modal"
      :adaptive="true"
      :reset="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <delete-item
        message="Da li zaista žekite da obrišete karticu"
        title="OBRIŠI KARTICU"
        :selectedItem="selectedCard"
        @deleteButtonClicked="deleteCard"
      />
    </modal>

    <!-- Title -->
    <h1 class="title has-text-success">Kartice</h1>
    <h2 class="subtitle">Administracija kartica zaposlenih.</h2>

    <!-- Table -->
    <vue-good-table
      theme="polar-bear"
      :columns="columns"
      :rows="rows"
      styleClass="vgt-table striped"
      :group-options="{
        enabled: true,
      }"
      :search-options="{
        enabled: true,
        searchFn: searchFunc,
        placeholder: 'Pretraži...',
      }"
    >
      <template slot="table-header-row" slot-scope="props">
        <span class="">
          <h2 class="is-size-6 has-text-weight-semibold has-text-left">
            {{ props.row.label }}
          </h2>
        </span>
      </template>
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'before'">
          <!-- edit icon -->
          <span class="icon has-text-info">
            <i
              class="fas fa-edit"
              v-show="props.row.isnew === false"
              @click="editRow(props.row)"
            >
              <font-awesome-icon icon="edit" />
            </i>
          </span>
          <!-- delete icon -->
          <span class="icon has-text-danger">
            <i
              class="fas fa-trash-alt"
              v-show="props.row.isnew === false"
              @click="deleteRow(props.row)"
            >
              <font-awesome-icon icon="trash-alt" />
            </i>
          </span>
          <!-- add new row button -->
          <button
            class="button is-info is-size-7"
            v-show="props.row.isnew === true"
            @click="addRow(props.row)"
          >
            Dodaj
          </button>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import UserService from "../../services/user.service";
import EditCard from "../parts/EditCard.vue";
import DeleteItem from "../parts/DeleteItem.vue";
import "vue-good-table/dist/vue-good-table.css";
import "vue-select/dist/vue-select.css";
import { VueGoodTable } from "vue-good-table";
import { CardBack, CardFront } from "../../models/card";

export default {
  components: {
    VueGoodTable,
    EditCard,
    DeleteItem,
  },
  name: "Cards",
  data() {
    return {
      selectedCard: CardFront,

      employees: [],

      columns: [
        {
          label: "Akcije",
          field: "before",
          sortable: false,
        },
        {
          label: "R.Br.",
          field: "cardId",
          type: "number",
          sortable: false,
        },
        {
          label: "Kod",
          field: "code",
          sortable: false,
        },
        {
          label: "Tip",
          field: "cardType",
          sortable: false,
        },
        {
          label: "Važi od",
          field: "validFrom",
          dateInputFormat: "yyyy.MM.dd",
          dateOutputFormat: "yyyy.MM.dd",
          sortable: false,
        },
        {
          label: "Važi do",
          field: "validUntil",
          dateInputFormat: "yyyy.MM.dd",
          dateOutputFormat: "yyyy.MM.dd",
          sortable: false,
        },
        { label: "Aktivna", field: "isActive", sortable: false },
      ],
      rows: [],
      errorMessage: "",
    };
  },
  mounted() {
    this.getEmployees();
  },
  methods: {
    getEmployees() {
      UserService.getEmployees().then((response) => {
        // reset ui
        this.resetUi();

        // get new data
        response.data.forEach((element) => {
          // populate employees
          this.employees.push({
            firstName: element.firstName,
            lastName: element.lastName,
            id: element.employeeId,
          });

          // populate rows
          let newCards = [];
          element.card.forEach((card) => {
            let crd = new CardFront(card);
            crd.updateEmployee(
              element.employeeId,
              element.firstName,
              element.lastName
            );
            newCards.push(crd);
          });
          let newRow = {
            mode: "span",
            label:
              element.firstName +
              " " +
              element.lastName +
              " (id: " +
              element.employeeId +
              ")",
            html: false,
            children: newCards,
          };
          newRow.children.push(
            new CardFront({
              cardId: null,
              code: null,
              remoteId: null,
              employeeId: null,
              name: null,
              cardType: null,
              validFrom: null,
              validUntil: null,
              vendorId: null,
              employee: {
                id: null,
                firstName: null,
                lastName: null,
                hiddenId: element.employeeId,
                hiddenFirstName: element.firstName,
                hiddenLastName: element.lastName,
              },
              isnew: true,
            })
          );
          this.rows.push(newRow);
        });
      });
    },
    searchFunc(row, col, cellValue, searchTerm) {
      let isCard = false;
      let isName = false;
      let isHiddenName = false;
      let theName = "";
      let theHiddenName = "";
      if (typeof cellValue === "string" || cellValue instanceof String) {
        isCard = cellValue.toLowerCase().includes(searchTerm.toLowerCase());
      }
      if (row.employee.firstName !== null) {
        theName = theName + row.employee.firstName;
      }
      if (row.employee.lastName !== null) {
        theName = theName + " " + row.employee.lastName;
      }
      if (row.employee.hiddenFirstName !== null) {
        theHiddenName = theHiddenName + row.employee.hiddenFirstName;
      }
      if (row.employee.hiddenLastName !== null) {
        theHiddenName = theHiddenName + " " + row.employee.hiddenLastName;
      }
      isName = theName.toLowerCase().includes(searchTerm.toLowerCase());
      isHiddenName = theHiddenName
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
      if (isName || isHiddenName || isCard) {
        return true;
      } else return false;
    },
    resetUi() {
      this.employees = [];
      this.rows = [];
    },
    addRow(crd) {
      this.selectedCard = crd;
      this.selectedCard.isActive = true;
      console.log(crd);
      this.$modal.show("add-card-modal");
    },
    deleteRow(crd) {
      this.selectedCard = crd;
      this.$modal.show("delete-card-modal");
    },
    editRow(crd) {
      this.selectedCard = crd;
      this.selectedCard.isActive = true;
      console.log(crd);
      this.$modal.show("edit-card-modal");
    },
    editCard(crd) {
      let cardToEdit = new CardBack(crd);

      UserService.putCard(cardToEdit).then(
        () => {
          // reload UI
          this.resetUi();

          this.getEmployees();
        },
        (error) => {
          this.errorMessage = this.collectErrorMessage(error);
          console.log(error);
        }
      );

      this.$modal.hide("edit-card-modal");
    },
    addCard(crd) {
      // create new card
      let newCard = new CardBack(crd);

      // call axios
      UserService.postCard(newCard).then(() => {
        this.getEmployees();

        // reset UI
        this.resetSelectedCard();
        this.$modal.hide("add-card-modal");
      });
    },
    deleteCard() {
      let cardToDelete = new CardBack(this.selectedCard);

      UserService.deleteCard(cardToDelete).then(
        () => {
          // reload emps
          this.resetUi();

          this.getEmployees();
        },
        (error) => {
          this.errorMessage = this.collectErrorMessage(error);
        }
      );
    },
    resetSelectedCard() {
      this.selectedCard = new CardFront({
        employee: {
          id: null,
          firstName: null,
          lastName: null,
        },
      });
    },
    collectErrorMessage(error) {
      let msg =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      return msg;
    },
  },
};
</script>
